import { getProcessFieldDateFormatOptions } from '@shared/components/ProcessFieldDynamicForm/processFieldDateFormatOptions';
import type { DatePickerMode } from '@shared/types/date';

import { useTranslation } from 'react-i18next';

export function useDateAiChatPlaceholder(
    format = 'DD.MM.YYYY',
    picker: DatePickerMode = 'date',
) {
    const { t } = useTranslation();
    const option = getProcessFieldDateFormatOptions(t)[picker].find(
        (option) => option.value === format,
    );
    return typeof option?.data === 'string' ? option.data : format;
}
